<div class="app-tfa-settings-dialog-container">
    <div class="tfa-settings-modal-holder">
        <div class="modal__close-button" (click)="onClose()" *ngIf="!hideCloseButtonOnTFAModal">
            <span matPrefix class="modal__close-button-icon"><i class="material-icons">clear</i></span>
        </div>
        <div class="tfa-settings-modal-title-holder" data-automation-id="tfa_settings_modal_title">
            <h3 *ngIf="twoFactorType ===2 && TFAStep !==4 || twoFactorType ===1 && TFAStep !==1 || !twoFactorType">
                Enable two-step verification</h3>
            <h3 *ngIf="(twoFactorType ===2 && TFAStep ===4)">
                Two-step verification enabled</h3>
        </div>
        <br>
        <form [formGroup]="accountSecurityTFAForm" #securityForm="ngForm">
            <div *ngIf="TFAStep === 0">
                <mat-radio-group formControlName="twoFactorType" class="enable-two-step-options__holder">
                    <div class="enable-two-step-option__description">Add an extra layer of security to your account by using a one-time security code. You can choose whether to send the
                    code to your email or mobile phone. Each time you log in to {{managerName}}, you'll need your password and your security code.</div>
                    <div class="enable-two-step-option__container" [ngClass]="{'selected': twoFactorType === 1}">
                        <mat-radio-button class="example-radio-button" value=1 (change)="onSetTFAType($event)"
                                          data-automation-id="radio_button_tfa_email"
                            [checked]="twoFactorType===1">
                        </mat-radio-button>
                        <div class="enable-two-step-option__label-container">
                            <h5>Send a security code to my email address</h5>
                        </div>
                    </div>
                    <div class="enable-two-step-option__container" [ngClass]="{'selected': twoFactorType === 2}">
                        <mat-radio-button class="example-radio-button" value=2 (change)="onSetTFAType($event)"
                            [checked]="twoFactorType===2">
                        </mat-radio-button>
                        <div class="enable-two-step-option__label-container">
                            <h5>Send a security code to my mobile phone</h5>
                        </div>
                    </div>
                </mat-radio-group>
                <div class="col-md-12 col-sm-12 account-security-form-footer">
                    <button disableRipple
                        class="a-rounded-button a-rounded-button--primary dialog__form-footer-button form" type="button"
                        [disabled]="twoFactorType===null || twoFactorType ===0"
                        (click)="onTFASubmit(securityForm)"
                    data-automation-id="button_tfa_next">{{getButtonText()}}</button>
                </div>
            </div>
            <div *ngIf="TFAStep === 2">
                <div class="enable-two-step-options__holder col-12">
                    <div>Enter your mobile phone number.</div>
                    <div class="enable-two-step-input__container col-md col-sm-12">
                        <mat-form-field appearance="outline">
                            <input matInput placeholder="Enter mobile number" [formControlName]="'profile_mobile_phone'" type="tel"
                                required minlength="8" maxlength="18" (ngModelChange)="resetIsMobileVerified()">
                            <div class="material-icons" *ngIf="!accountSecurityTFAForm.controls['profile_mobile_phone'].errors">
                                <md-icon class="md-success material-icons">check_circle</md-icon>
                            </div>
                            <div class="material-icons" *ngIf="accountSecurityTFAForm.controls['profile_mobile_phone'].errors">
                                <md-icon class="md-error material-icons">highlight_off</md-icon>
                            </div>
                        </mat-form-field>
                        <mat-error
                            *ngIf="accountSecurityTFAForm.controls['profile_mobile_phone'].errors?.pattern && accountSecurityTFAForm.controls['profile_mobile_phone'].touched">
                            Sorry, that mobile number is invalid.
                        </mat-error>
                        <mat-error
                            *ngIf="accountSecurityTFAForm.controls['profile_mobile_phone'].errors?.minlength && accountSecurityTFAForm.controls['profile_mobile_phone'].touched">
                            Mobile phone numbers must be at least eight digits long.
                        </mat-error>
                        <mat-error
                            *ngIf="accountSecurityTFAForm.controls['profile_mobile_phone'].errors?.required  && accountSecurityTFAForm.controls['profile_mobile_phone'].touched">
                            Please enter a mobile phone number for verification.
                        </mat-error>
                    </div>
                </div>
                <div class="col-12 account-security-form-footer">
                    <button disableRipple class="a-rounded-button a-rounded-button--primary dialog__form-footer-button form"
                        type="button" (click)="onRequestSMSVerification(securityForm)"
                        [disabled]="!securityForm.valid">{{getButtonText()}}</button>
                    <button disableRipple class="a-rounded-button a-rounded-button--primary-outline dialog__form-footer-button form"
                        type="button" (click)="onSetTFAStep(0)">{{ 'Back' }}</button>
                </div>
            </div>
        </form>
        <form *ngIf="TFAStep === 3 || TFAStep === 4" [formGroup]="mobileVerificationForm" #verificationForm="ngForm">
            <div>
                <div class="enable-two-step-options__holder col-12">
                    <div>We sent a one-time security code to {{twoFactorPhone}}. Enter it below to verify your mobile phone
                        number.</div>
                    <div class="enable-two-step-input__container col-md-6 col-sm-12 col-12">
                        <mat-form-field class="default-form-input-container" appearance="outline">
                            <input style="width: 100%" matInput placeholder="4-character-code" [formControlName]="'verificationCode'"
                                (ngModelChange)="resetErrorMessage()">
                            <div class="material-icons" *ngIf="(SMSVerificationStatus === SMSVerifiactionSuccess)">
                                <md-icon class="md-success">check_circle</md-icon>
                            </div>
                            <div class="material-icons" *ngIf="(SMSVerificationStatus === SMSVerifiactionFailed)">
                                <md-icon class="md-error">highlight_off</md-icon>
                            </div>
                        </mat-form-field>
                        <mat-error *ngIf="(SMSVerificationStatus === SMSVerifiactionFailed)">
                            <span>Sorry, that security code is incorrect.</span>
                        </mat-error>
                    </div>
                </div>
                <div *ngIf="TFAStep === 3" class="col-12 account-security-form-footer">
                    <button disableRipple
                        class="a-rounded-button a-rounded-button--primary dialog__form-footer-button form" type="button"
                        (click)="onVerifySMS(verificationForm)" [disabled]="!verificationForm.valid">{{
                        'Verify'}}</button>
                    <button disableRipple
                        class="a-rounded-button a-rounded-button--primary-outline dialog__form-footer-button form"
                        type="button" (click)="onSetTFAStep(2); resetMobileVerificationForm()">{{ 'Back' }}</button>
                </div>
                <div *ngIf="TFAStep === 4" class="col-12 account-security-form-footer">
                    <button disableRipple
                        class="a-rounded-button a-rounded-button--primary dialog__form-footer-button form" type="button"
                        (click)="onClose()">{{ 'Done'}}</button>
                </div>
            </div>
        </form>
    </div>
    <app-spinner *ngIf="showSpinner" class="spinner"></app-spinner>
</div>